export default __webpack_public_path__ + "static/media/category_d1.4d599ffa.svg";